import React from "react";
import { Container, Stack, Grid2 } from "@mui/material";
import CampaignShowCaseCard from "./CampaignShowCaseCard";
import { Campaign } from "../../../interfaces/sanity/sanityClasses";
import COLORS from "../../../constants/colors";
import useIsMobile from "../../../hooks/useIsMobile";
import HostCampaignShowCaseCard from "../CampaignHostCard";
import StudentloanCampaignShowCaseCard from "../CampaignStudentloanCard";

interface Props {
  activeCampaigns: {
    node: Campaign;
  }[];
}

const CampaignShowcase = ({ activeCampaigns }: Props) => {
  const isMobile = useIsMobile();
  return (
    <section>
      <Stack sx={{ bgcolor: COLORS.DARK_BLUE[100], paddingY: "80px" }}>
        <Container>
          <Stack flexDirection={{ xs: "column", md: "row" }} gap="50px">
            {activeCampaigns.length < 1 ? (
              <Grid2
                container={!isMobile}
                spacing={{ xs: "32px", md: "40px" }}
                direction={{ xs: "column", md: "row" }}
              >
                <Grid2 size={{ xs: 6, md: 6 }} mt={2}>
                  <StudentloanCampaignShowCaseCard />
                </Grid2>
                <Grid2 size={{ xs: 6, md: 6 }} mt={2}>
                  <HostCampaignShowCaseCard />
                </Grid2>
              </Grid2>
            ) : (
              activeCampaigns.map((activeCampaign, i) => (
                <CampaignShowCaseCard
                  activeCampaign={activeCampaign.node}
                  multipleActiveCampaigns={activeCampaigns.length > 1}
                  key={i}
                />
              ))
            )}
          </Stack>
        </Container>
      </Stack>
    </section>
  );
};
export default CampaignShowcase;
